import { render, staticRenderFns } from "./StatusChangeDialog.vue?vue&type=template&id=551dd413&scoped=true"
import script from "./StatusChangeDialog.vue?vue&type=script&lang=js"
export * from "./StatusChangeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551dd413",
  null
  
)

export default component.exports